// extracted by mini-css-extract-plugin
module.exports = {"code":"BaseService_code__xJ77x"};